// Major cities with countries
export const cities = [
  "Aberdeen, UK",
  "Bath, UK",
  "Belfast, UK",
  "Birmingham, UK",
  "Blackpool, UK",
  "Bournemouth, UK",
  "Bradford, UK",
  "Brighton, UK",
  "Bristol, UK",
  "Cambridge, UK",
  "Canterbury, UK",
  "Cardiff, UK",
  "Carlisle, UK",
  "Chester, UK",
  "Chichester, UK",
  "Coventry, UK",
  "Derby, UK",
  "Dover, UK",
  "Dublin, Ireland",
  "Durham, UK",
  "Edinburgh, UK",
  "Exeter, UK",
  "Galway, Ireland",
  "Glasgow, UK",
  "Gloucester, UK",
  "Hereford, UK",
  "Hull, UK",
  "Inverness, UK",
  "Ipswich, UK",
  "Leeds, UK",
  "Leicester, UK",
  "Lincoln, UK",
  "Liverpool, UK",
  "London, UK",
  "Manchester, UK",
  "Milton Keynes, UK",
  "Montreal, Canada",
  "Newcastle, UK",
  "Norwich, UK",
  "Nottingham, UK",
  "Ottawa, Canada",
  "Oxford, UK",
  "Peterborough, UK",
  "Perth, Australia",
  "Plymouth, UK",
  "Portsmouth, UK",
  "Reading, UK",
  "Salisbury, UK",
  "Sheffield, UK",
  "Southampton, UK",
  "St Albans, UK",
  "Stoke-on-Trent, UK",
  "Sunderland, UK",
  "Swansea, UK",
  "Sydney, Australia",
  "Toronto, Canada",
  "Truro, UK",
  "Vancouver, Canada",
  "Winchester, UK",
  "Worcester, UK",
  "York, UK"
].sort();

export function filterCities(query: string): string[] {
  const normalizedQuery = query.toLowerCase().trim();
  return cities.filter(city => 
    city.toLowerCase().startsWith(normalizedQuery)
  );
}